import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { firstValueFrom } from 'rxjs';

import { GenericModalNotesComponent } from '@shared/components';

@Injectable({
  providedIn: 'root',
})
export class NotesModalService {
  private readonly _dialog = inject(MatDialog);

  public async onOpenModalAddNote(data: string) {
    const dialogRef = this._dialog.open(GenericModalNotesComponent, {
      panelClass: 'home-modal-notes',
      data,
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }
}
